import { gql } from '@apollo/client'
import { SABRE_PRODUCT_FRAGMENT } from '../fragments'

export const SABRE_CREATE_PRODUCT = gql`
  mutation CreateProduct($input: CreateProductInput!) {
    createProduct(input: $input) {
      product {
        ...Product
      }
    }
  }
  ${SABRE_PRODUCT_FRAGMENT}
`
